import { render, staticRenderFns } from "./modifyPaper.vue?vue&type=template&id=21cccb2a&scoped=true"
import script from "./modifyPaper.vue?vue&type=script&lang=js"
export * from "./modifyPaper.vue?vue&type=script&lang=js"
import style0 from "./modifyPaper.vue?vue&type=style&index=0&id=21cccb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cccb2a",
  null
  
)

export default component.exports